<template>
  <div @click="onClick"
       class="employers-lt-header-mob-menu">
    <nav class="employers-lt-header-mob-menu__menu">
      <a :href="getRoute({name: 'vacancies'})"
         class="base-link employers-lt-header-mob-menu__menu-link">
        <BaseSvg name="ico-question"
                 width="1.5rem"
                 height="1.5rem"
                 class="base-link__ico"/>
        <span class="base-link__text">{{ section.link_1 }}</span>
      </a>
      <a :href="getRoute({name: 'vacancies'})"
         class="base-link employers-lt-header-mob-menu__menu-link">
        <BaseSvg name="ico-list-2"
                 width="1.7rem"
                 height="1.5rem"
                 class="base-link__ico"/>
        <span class="base-link__text">{{ section.link_2 }}</span>
      </a>
    </nav>

    <a href="#employers-lt-order"
       @click.prevent="$scrollTo('#employers-lt-order', {offset: -58})"
       class="employers-lt-header-mob-menu__btn  base-btn  base-btn--blue">
      {{ section.button }}
    </a>
  </div>
</template>

<script>
  export default {
    name: 'EmployersLTPageHeaderMobMenu',
    props: {
      section: Object,
      getRoute: Function
    },
    data() {
      return {}
    },
    methods: {
      onClick(event) {
        const target = event.target

        if (target.closest('a, button')) {
          this.$emit('close')
        }
      }
    }
  }
</script>

<style lang="less">

</style>
